/* -------------- Operation based interfaces -------------- */

// LIST 
export interface MobileAppVersionListItem {
	versionId: string;
	platform: string;
	version: string;
	appId: number;
	forceUpdate: boolean;
}

export interface MobileAppVersionListApiResponse {
	result: {
		items: MobileAppVersionListItem[];
	};
	error: string | null;
	isSuccessful: boolean;
}

// GET
export interface MobileAppVersionDetail {
	platform: string;
	version: string;
	forceUpdate: boolean;
	appId: number | undefined;
	versionId?: string;
}

export interface MobileAppVersionGetApiResponse {
	result: {
		versionId: string;
		platform: string;
		version: string;
		forceUpdate: boolean;
		appId: number | undefined;
	}
	error: string | null;
	isSuccessful: boolean;
}

// ADD/UPDATE
export interface MobileAppVersionData {
	platform: string;
	version: string;
	forceUpdate: boolean | undefined;
	appId: number | undefined;
	versionId: string;
}

export const defaultMobileAppVersionData: MobileAppVersionData = {
	platform: "",
	version: "",
	forceUpdate: undefined,
	appId: undefined,
	versionId: ""
};

// Page States
export type OperationStatus =
	| { type: "idle" }
	| { type: "loading"; operation: "add" | "fetch" | "update" | "delete" }
	| { type: "error"; operation: string; message: string };
